const DB_IME = "zupnija-tunjice-admin-galerija";
const DB_VERZIJA = 1;
const SHRANJENI_DOGODKI = "adminGalerijaDogodki";
const SHRANJENE_SLIKE = "slike";

function odpriBazo(){
	return new Promise((resolve, reject) => {
		const zahteva = window.indexedDB.open(DB_IME, DB_VERZIJA);

		zahteva.onupgradeneeded = function(){
			const db = zahteva.result;

			if(!db.objectStoreNames.contains(SHRANJENE_SLIKE)){
				db.createObjectStore(SHRANJENE_SLIKE);
			}
		};

		zahteva.onsuccess = function(){
			resolve(zahteva.result);
		};

		zahteva.onerror = function(){
			reject(zahteva.error);
		};
	});
}

function shraniBlob(kljuc, datoteka){
	return odpriBazo().then(db => {
		return new Promise((resolve, reject) => {
			const transakcija = db.transaction(SHRANJENE_SLIKE, "readwrite");
			transakcija.objectStore(SHRANJENE_SLIKE).put(datoteka, kljuc);
			transakcija.oncomplete = function(){
				db.close();
				resolve();
			};
			transakcija.onerror = function(){
				db.close();
				reject(transakcija.error);
			};
		});
	});
}

function preberiBlob(kljuc){
	return odpriBazo().then(db => {
		return new Promise((resolve, reject) => {
			const transakcija = db.transaction(SHRANJENE_SLIKE, "readonly");
			const zahteva = transakcija.objectStore(SHRANJENE_SLIKE).get(kljuc);

			zahteva.onsuccess = function(){
				resolve(zahteva.result);
			};

			zahteva.onerror = function(){
				reject(zahteva.error);
			};

			transakcija.oncomplete = function(){
				db.close();
			};
		});
	});
}

function preberiMetapodatke(){
	try{
		return JSON.parse(window.localStorage.getItem(SHRANJENI_DOGODKI)) || [];
	}
	catch(e){
		return [];
	}
}

function shraniMetapodatke(dogodki){
	window.localStorage.setItem(SHRANJENI_DOGODKI, JSON.stringify(dogodki));
	window.dispatchEvent(new CustomEvent("adminGalerijaOsvezena"));
}

export function slugify(vrednost){
	return vrednost
		.toString()
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "") || "dogodek";
}

export async function dodajAdminDogodek(vnos){
	const id = Date.now() + "-" + slugify(vnos.naslov);
	const slike = [];

	for(let i = 0; i < vnos.slike.length; i++){
		const datoteka = vnos.slike[i];
		const kljuc = id + "-" + i + "-" + datoteka.name;

		await shraniBlob(kljuc, datoteka);

		slike.push({
			ime: datoteka.name,
			tip: datoteka.type,
			kljuc: kljuc
		});
	}

	const dogodek = {
		id: id,
		naslov: vnos.naslov.trim().toUpperCase(),
		opis: vnos.opis.trim(),
		avtor: vnos.avtor.trim(),
		dodal: vnos.dodal || "",
		ustvarjeno: new Date().toISOString(),
		naslovnica: slike[0] ? slike[0].kljuc : "",
		slike: slike
	};

	const dogodki = preberiMetapodatke();
	shraniMetapodatke([dogodek].concat(dogodki));

	return dogodek;
}

export async function preberiAdminDogodke(){
	const dogodki = preberiMetapodatke();

	return Promise.all(dogodki.map(async dogodek => {
		const slike = [];

		for(let i = 0; i < dogodek.slike.length; i++){
			const slika = dogodek.slike[i];
			const blob = await preberiBlob(slika.kljuc);

			if(blob){
				const url = URL.createObjectURL(blob);
				slike.push({
					ime: slika.ime,
					mala: url,
					velika: url
				});
			}
		}

		return {
			...dogodek,
			naslovnicaUrl: slike[0] ? slike[0].mala : "",
			slikeUrl: slike
		};
	}));
}

export function preberiAdminDogodkeMeta(){
	return preberiMetapodatke();
}
